import CrimeList from "./components/crimeList";

function App() {
  return (
    <div>
      <CrimeList />
    </div>
  );
}

export default App;
